/* global FB */
import React from 'react';
import PropTypes from 'prop-types';
import { attachScript } from '../../../../../common/utils/attach-script';
import { AccessibleSocialButton } from './accessible-social-button';
const LIBRARY_URL = 'https://connect.facebook.net/en_US/sdk.js';
export class FacebookButton extends React.Component {
    constructor() {
        super(...arguments);
        this.init = (containerNode) => {
            FB.init({ xfbml: true, version: 'v2.5' });
            return new Promise((resolve) => {
                FB.XFBML.parse(containerNode, resolve);
            });
        };
    }
    attachScript() {
        if (window.FB) {
            return Promise.resolve();
        }
        return attachScript(LIBRARY_URL);
    }
    render() {
        const { cardData, isAccessible, facebookButtonTitle } = this.props;
        return (React.createElement(AccessibleSocialButton, { isAccessible: isAccessible, attachScript: this.attachScript, title: facebookButtonTitle, initButton: this.init },
            React.createElement("div", { className: "fb-like", "data-href": cardData.url, "data-layout": "button", "data-action": "like" })));
    }
}
FacebookButton.propTypes = {
    cardData: PropTypes.object,
    isAccessible: PropTypes.bool,
    facebookButtonTitle: PropTypes.string,
};
//# sourceMappingURL=facebook.js.map